import { registerBlockType } from "@wordpress/blocks";
import {
  useBlockProps,
  InspectorControls,
  RichText,
} from "@wordpress/block-editor";
import { PanelBody, TextControl, Button } from "@wordpress/components";
import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import metadata from "./block.json";

registerBlockType(metadata.name, {
  ...metadata,
  edit: ({ attributes, setAttributes }) => {
    const { carouselId, slides } = attributes;

    const updateSlide = (index, field, value) => {
      const newSlides = [...slides];
      newSlides[index][field] = value;
      setAttributes({ slides: newSlides });
    };

    const updateItem = (slideIndex, itemIndex, value) => {
      const newSlides = [...slides];
      newSlides[slideIndex].items[itemIndex] = value;
      setAttributes({ slides: newSlides });
    };

    const addItem = (slideIndex) => {
      const newSlides = [...slides];
      newSlides[slideIndex].items.push("");
      setAttributes({ slides: newSlides });
    };

    const removeItem = (slideIndex, itemIndex) => {
      const newSlides = [...slides];
      newSlides[slideIndex].items.splice(itemIndex, 1);
      setAttributes({ slides: newSlides });
    };

    const addSlide = () => {
      setAttributes({
        slides: [...slides, { year: "", title: "", items: [""] }],
      });
    };

    const removeSlide = (index) => {
      const newSlides = slides.filter((_, i) => i !== index);
      setAttributes({ slides: newSlides });
    };

    return (
      <div {...useBlockProps()}>
        <Fragment>
          <InspectorControls>
            <PanelBody title="Carousel Settings">
              <TextControl
                label="Carousel ID"
                value={carouselId}
                onChange={(val) => setAttributes({ carouselId: val })}
                help="Must be unique on the page"
              />
            </PanelBody>
          </InspectorControls>

          <div className="timeline-carousel-editor">
            <h3>{__("Monfort timeline Carousel")}</h3>
            {slides.map((slide, slideIndex) => (
              <div
                className="editor-slide border p-3 mb-4 bg-light rounded"
                key={slideIndex}
              >
                <TextControl
                  label="Year"
                  value={slide.year}
                  onChange={(val) => updateSlide(slideIndex, "year", val)}
                />
                <TextControl
                  label="Title"
                  value={slide.title}
                  onChange={(val) => updateSlide(slideIndex, "title", val)}
                />

                <strong>Items:</strong>
                {slide.items.map((item, itemIndex) => (
                  <div
                    key={itemIndex}
                    className="d-flex align-items-center mb-2"
                  >
                    <TextControl
                      value={item}
                      onChange={(val) => updateItem(slideIndex, itemIndex, val)}
                    />
                    <Button
                      className="ms-2"
                      isDestructive
                      variant="secondary"
                      onClick={() => removeItem(slideIndex, itemIndex)}
                      aria-label="Remove item"
                    >
                      ✕
                    </Button>
                  </div>
                ))}
                <Button
                  variant="secondary"
                  onClick={() => addItem(slideIndex)}
                  className="mb-3"
                >
                  + Add List Item
                </Button>

                <Button
                  isDestructive
                  variant="secondary"
                  onClick={() => removeSlide(slideIndex)}
                >
                  Remove Slide
                </Button>
              </div>
            ))}

            <Button variant="primary" onClick={addSlide}>
              + Add New Slide
            </Button>
          </div>
        </Fragment>
      </div>
    );
  },
  save: ({ attributes }) => {
    const { carouselId, slides } = attributes;

    return (
      <div className="container-fluid top-gradient-bg p-0 position-relative">
        <div class="custom-swiper-inner mb-5 p-5">
          <div className="swiper-container " id={carouselId}>
            <div className="swiper-wrapper">
              {slides.map((slide, index) => (
                <div className="swiper-slide" key={index}>
                  <div className="gallery-cell border-large white-bg rounded p-4 h-100">
                    <h1 className="text-center mediumGreen">{slide.year}</h1>
                    <h4 className="text-center mb-4">{slide.title}</h4>
                    <ol>
                      {slide.items.map((item, j) => (
                        <li key={j}>{item}</li>
                      ))}
                    </ol>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation buttons (optional) */}
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>

            {/* Pagination (optional) */}
            <div className="swiper-pagination"></div>
          </div>
        </div>

        {/* Init Swiper inline or via separate script */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
            document.addEventListener('DOMContentLoaded', function () {
              new Swiper('#${carouselId}', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: false,
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
                breakpoints: {
                  768: { slidesPerView: 1 },
                  992: { slidesPerView: 2 },
                  1200: { slidesPerView: 3 },
                }
              });
            });
          `,
          }}
        />
      </div>
    );
  },
});
